var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "table",
          class: { "disabled-table": _vm.disabled },
          attrs: {
            data: _vm.pageData.activeDiagRecord[_vm.tableCode],
            "highlight-current-row": "",
          },
          on: {
            "row-click": _vm.handleRowClick,
            "current-change": _vm.handleCurrentChange,
          },
        },
        [
          _vm.tableCode === "chmedPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    effectiveSign: "1",
                    materielTypeSign: "3",
                  },
                  width: 180,
                  "filed-list": [
                    { code: "materielCode", name: "编码" },
                    { code: "materielName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  "search-key": "pinyinCode",
                  name: "药品名称",
                  code: "materielName",
                },
                on: { onPopupClick: _vm.medPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "chmedPrescriptionItemList"
            ? _c("table-select-item", {
                attrs: {
                  edit: !_vm.disabled,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              })
            : _vm._e(),
          _vm.tableCode === "chmedPrescriptionItemList"
            ? _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 0,
                  min: 1,
                  edit: !_vm.disabled,
                  name: "单剂数量",
                  code: "singleNum",
                },
              })
            : _vm._e(),
          _vm.tableCode === "chmedPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  "search-key": "pinyinCode",
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmeddic",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    medDirectoryCode: "JZ",
                    effectiveSign: "1",
                  },
                  width: 140,
                  "filed-list": [
                    { code: "medDictionaryCode", name: "编码" },
                    { code: "medDictionaryName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  name: "煎法",
                  code: "decoctionName",
                },
                on: { onPopupClick: _vm.decoctionPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "chmedPrescriptionItemList"
            ? _c("el-table-column", {
                attrs: { width: 140, label: "总数", prop: "doseNum" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  row["singleNum"] *
                                  _vm.pageData.activeDiagRecord
                                    .chmedPrescription.doseNum
                                ).toFixed(0)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  241727945
                ),
              })
            : _vm._e(),
          _vm.tableCode === "djPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    effectiveSign: "1",
                    materielTypeSign: "3",
                  },
                  width: 180,
                  "filed-list": [
                    { code: "materielCode", name: "编码" },
                    { code: "materielName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  "search-key": "pinyinCode",
                  name: "药品名称",
                  code: "materielName",
                },
                on: { onPopupClick: _vm.medPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "djPrescriptionItemList"
            ? _c("table-select-item", {
                attrs: {
                  edit: !_vm.disabled,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              })
            : _vm._e(),
          _vm.tableCode === "djPrescriptionItemList"
            ? _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 0,
                  min: 1,
                  edit: !_vm.disabled,
                  name: "单剂数量",
                  code: "singleNum",
                },
              })
            : _vm._e(),
          _vm.tableCode === "djPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  "search-key": "pinyinCode",
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmeddic",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    medDirectoryCode: "JZ",
                    effectiveSign: "1",
                  },
                  width: 140,
                  "filed-list": [
                    { code: "medDictionaryCode", name: "编码" },
                    { code: "medDictionaryName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  name: "煎法",
                  code: "decoctionName",
                },
                on: { onPopupClick: _vm.decoctionPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "djPrescriptionItemList"
            ? _c("el-table-column", {
                attrs: { width: 140, label: "总数", prop: "doseNum" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  row["singleNum"] *
                                  _vm.pageData.activeDiagRecord.djPrescription
                                    .doseNum
                                ).toFixed(0)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2460259168
                ),
              })
            : _vm._e(),
          _vm.tableCode === "dsPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  url: "pharmacy/pharmacy/cooperation/cooperationmedicine",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    effectiveSign: "1",
                    cooperationPharmacyCode:
                      _vm.pageData.activeDiagRecord.dsPrescription.pharmacyCode,
                  },
                  width: 180,
                  "filed-list": [
                    { code: "materielCode", name: "编码" },
                    { code: "materielName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  "search-key": "pinyinCode",
                  name: "药品名称",
                  code: "materielName",
                },
                on: { onPopupClick: _vm.medPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "dsPrescriptionItemList"
            ? _c("table-select-item", {
                attrs: {
                  edit: !_vm.disabled,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              })
            : _vm._e(),
          _vm.tableCode === "dsPrescriptionItemList"
            ? _c("table-number-item", {
                attrs: {
                  width: 140,
                  precision: 0,
                  min: 1,
                  edit: !_vm.disabled,
                  name: "数量",
                  code: "sellingNum",
                },
              })
            : _vm._e(),
          _vm.tableCode === "dsPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  "search-key": "pinyinCode",
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmeddic",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    medDirectoryCode: "JZ",
                    effectiveSign: "1",
                  },
                  width: 140,
                  "filed-list": [
                    { code: "medDictionaryCode", name: "编码" },
                    { code: "medDictionaryName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  name: "煎法",
                  code: "decoctionName",
                },
                on: { onPopupClick: _vm.decoctionPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "medPrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    effectiveSign: "1",
                    materielTypeSign: "1",
                  },
                  "column-width": 250,
                  "search-key": "pinyinCode",
                  "filed-list": [
                    { code: "materielCode", name: "编码" },
                    { code: "materielName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  name: "药品名称",
                  code: "materielName",
                },
                on: { onPopupClick: _vm.medPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "medPrescriptionItemList"
            ? _c("table-select-item", {
                attrs: {
                  edit: !_vm.disabled,
                  "default-value": "1",
                  disabled: true,
                  width: 120,
                  name: "品质标识",
                  code: "qualitySign",
                  options: [
                    { key: "1", value: "一般" },
                    { key: "2", value: "精品" },
                  ],
                },
              })
            : _vm._e(),
          _vm.tableCode === "medPrescriptionItemList"
            ? _c("ik-column-number", {
                attrs: {
                  code: "sellingNum",
                  "column-width": 150,
                  precision: 0,
                  min: 1,
                  name: "销售数量",
                },
              })
            : _vm._e(),
          _vm.tableCode === "medPrescriptionItemList"
            ? _c("ik-column-text", {
                attrs: { code: "medAdvice", name: "医嘱" },
              })
            : _vm._e(),
          _vm.tableCode === "servePrescriptionItemList"
            ? _c("ik-column-text", {
                attrs: { edit: false, code: "materielCode", name: "方案编码" },
              })
            : _vm._e(),
          _vm.tableCode === "servePrescriptionItemList"
            ? _c("table-popup-item", {
                attrs: {
                  url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel",
                  searcher: {
                    storeCode: _vm.pageData.storeCode,
                    effectiveSign: "1",
                    materielTypeSign: "4",
                  },
                  width: 120,
                  "search-key": "pinyinCode",
                  "filed-list": [
                    { code: "materielCode", name: "编码" },
                    { code: "materielName", name: "名称" },
                  ],
                  edit: !_vm.disabled,
                  name: "方案名称",
                  code: "materielName",
                },
                on: { onPopupClick: _vm.medPopupClick },
              })
            : _vm._e(),
          _vm.tableCode === "servePrescriptionItemList"
            ? _c("ik-column-number", {
                attrs: {
                  code: "sellingNum",
                  precision: 0,
                  min: 1,
                  name: "销售数量",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", disabled: _vm.disabled },
                        on: {
                          click: function ($event) {
                            return _vm.delRow(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "add-btn-con w-full flex flex-row justify-center align-center",
          class: { "disabled-add-btn": _vm.disabled },
          on: { click: _vm.addRow },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "add-btn w-full h-full flex flex-row justify-center align-center",
            },
            [_vm._v(" + 添加 + ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }